import { Badge } from "@repo/ui/components/badge";
import { Card, CardContent } from "@repo/ui/components/card";
import { createFileRoute, Link, type LinkOptions, Outlet } from "@tanstack/react-router";
import { motion } from "framer-motion";

export const Route = createFileRoute("/_authed/filenames")({
  component: RouteComponent,
});

const navItems: { label: string; to: LinkOptions["to"] }[] = [
  {
    label: "Game Titles",
    to: "/filenames/game-titles",
  },
  {
    label: "Teams",
    to: "/filenames/teams",
  },
  {
    label: "Players",
    to: "/filenames/players",
  },
  {
    label: "Import filenames",
    to: "/filenames/import",
  },
];

function RouteComponent() {
  return (
    <div className="grid gap-4">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Filename previews</h1>
        <p className="text-sm text-muted-foreground">
          Use one quiet naming pattern that works cleanly on iPad, AirDrop, and Files.
        </p>
      </div>

      <Card size="sm">
        <CardContent className="flex flex-wrap gap-2 pt-6 text-xs text-muted-foreground">
          <Badge variant="outline">ascii only</Badge>
          <Badge variant="outline">lowercase</Badge>
          <Badge variant="outline">underscores between parts</Badge>
          <Badge variant="outline">dashes inside words</Badge>
          <Badge variant="outline">stable .jpg suffix</Badge>
        </CardContent>
      </Card>

      <SubHeader />
      <Outlet />
    </div>
  );
}

function SubHeader() {
  return (
    <nav className="border-b text-muted">
      <ul className="flex flex-wrap gap-2">
        {navItems.map((nav) => (
          <motion.li key={nav.to} initial={false} className="relative px-3 py-2 text-sm">
            <Link
              to={nav.to}
              className="text-muted-foreground transition-colors duration-200 ease-in-out [&.active]:text-foreground"
            >
              {({ isActive }) => (
                <>
                  {nav.label}
                  {isActive ? (
                    <motion.div
                      className="absolute right-0 bottom-0 left-0 h-0.5 bg-primary"
                      id="underline"
                      layoutId="underline"
                    />
                  ) : null}
                </>
              )}
            </Link>
          </motion.li>
        ))}
      </ul>
    </nav>
  );
}
